<template>
  <div
    :class="[{textCenter:'text-center'},`display-${size} ${color}--text font-weight-black`]"
  >
    {{ content }}
  </div>
</template>

<script>
  export default {
    name: 'BaseDisplayTitle',

    props: {
			content: { type: String, default: '' },
      size: { type: String, default: '1' },
      color: { type: String, default: '' },
      textCenter: { type: Boolean, default: false }
		}
  }
</script>

<style lang="scss" scoped>

</style>